import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { CircleCloseIcon } from '@icons/CircleCloseIcon'
import { CircleSuccessLineIcon } from '@icons/CircleSuccessLineIcon'

import { Button } from '@global/button/Button'

import { ButtonActionsBox } from '../Common/ButtonActionsBox'

interface ButtonActionsProps {
  isCheckBoxActive?: boolean
  onCheckBoxClick?: () => void
  onApprove?: () => void
  onReject?: () => void
  hasData?: boolean
}

export const ButtonActions: FC<ButtonActionsProps> = (props) => {
  const { isCheckBoxActive, hasData, onCheckBoxClick, onApprove, onReject } = props

  const { t } = useTranslation()

  return (
    <ButtonActionsBox isCheckBoxActive={isCheckBoxActive} onCheckBoxClick={onCheckBoxClick}>
      <Button.New
        appearance='secondary'
        size='XS'
        disabled={!hasData}
        onClick={onReject}
        renderLeftIcon={() => <CircleCloseIcon />}
      >
        {t('IB.RebatesPage.ApprovalsPage.Reject')}
      </Button.New>
      <Button.New
        appearance='secondary'
        size='XS'
        disabled={!hasData}
        onClick={onApprove}
        renderLeftIcon={() => <CircleSuccessLineIcon />}
      >
        {t('IB.RebatesPage.ApprovalsPage.Approve')}
      </Button.New>
    </ButtonActionsBox>
  )
}
